import { SelectOption } from '@/components/elements/select'

export const shippingTypeMap: SelectOption[] = [
    { label: 'Pago', value: 'payed' },
    { label: 'Paga en casa', value: 'payment_on_delivery' },
]
